import { takeEvery, call, put, all, fork, spawn } from 'redux-saga/effects';

import { settingsActions } from './actions';
import { settingsService } from '../../services/settings';

import { onError } from '../../utils/onError';
import { openNotification } from '../../utils/openNotification';

import { notificationType } from '../../constants/notification';

function* loadSettingsListWatcher() {
  yield takeEvery(settingsActions.LOAD_SETTINGS_LIST, function* () {
    try {
      const response = yield call(settingsService.loadSettingsList);
      yield put(settingsActions.loadSettingsListSuccess(response));
    } catch (e) {
      yield put(settingsActions.loadSettingsListFail(e));
      yield spawn(onError, e);
    }
  });
}

function* updateSettingsWatcher() {
  yield takeEvery(settingsActions.UPDATE_SETTINGS, function* ({ payload }) {
    const { settingsId, settings } = payload;
    try {
      const response = yield call(settingsService.updateSettings, settingsId, settings);
      yield put(settingsActions.updateSettingsSuccess(response));
      yield spawn(openNotification, notificationType.success, 'global.editRecordSuccess');
    } catch (e) {
      yield put(settingsActions.updateSettingsFail(e));
      yield spawn(onError, e);
    }
  });
}

export function* settingsSaga() {
  yield all([fork(loadSettingsListWatcher), fork(updateSettingsWatcher)]);
}
